// extracted by mini-css-extract-plugin
export default {"modal":"BlockImageRotateModal_modal__9eJ9I","cropContainer":"BlockImageRotateModal_cropContainer__sx-e3","rotateButtonContainer":"BlockImageRotateModal_rotateButtonContainer__lN9T4"};